import React from "react";
import { Nav, Container, Row, Col} from "react-bootstrap";

const CatPanelForCatalog = ({ categoryData, getImagePath }) => {
    if (!categoryData) return  <div>Загрузка...</div>;
//    console.log("categoryData",categoryData)
    return (
        <Container className="mb-4 catpanel">
            <Row>
                {categoryData.childCatalogs.map((cat, index) => (
                    <>
                        <Col
                            key={cat.id}
                            className={cat.classNameCol}
                        >
                            <div className={cat.classNameDiv} style={{ maxHeight: '250px'}}>
                                <Nav.Link
                                    className="p-4"
                                    style={{ cursor: 'pointer'}}
                                    to={`/catalog/${cat.url}`} // Динамический путь
                                    href={`/catalog/${cat.url}`} // Также добавляем для обычных ссылок
                                 >
                                    <h2 className="text-light">{cat.name}</h2>
                                    <img className={cat.classNameImg} src={getImagePath(cat.imageGroup)} alt={cat.name} />
                                </Nav.Link> 
                            </div>
                        </Col>

                        {/* Вставляем пустой div между 4 и 5 элементом */  }
                        {(index === 3 || index === 7) && (
                            <div className="d-none d-xl-block w-100" key="divider"></div>
                        )}
                    </>
                ))} 
         </Row>
        </Container>
    );
};

export default CatPanelForCatalog;